import React from 'react';
import PropTypes from 'prop-types';
import StencilFlap from 'shared/components/parameters/StencilFlap';
import StencilLength from 'shared/components/parameters/StencilLength';
import StencilWidth from 'shared/components/parameters/StencilWidth';
import StencilThickness from 'shared/components/parameters/StencilThickness';
import StencilAlignment from 'shared/components/parameters/StencilAlignment';
import StencilFiducialData from 'shared/components/parameters/StencilFiducialData';

import PrototypeStencilType from 'shared/product_tabs/tab_stencils/components/PrototypeStencilType';
import ApertureCount from 'shared/product_tabs/tab_stencils/components/ApertureCount';
import { stencilLengthOptions, stencilsWidthOptions } from 'shared/data/selectOptions';

const PrototypeSmtStencil = ({ product, onChangeParameter, parameters, reference, validator }) => {
  const groupName = `parameters[${reference + 1}]`;

  return (
    <div className="product-parameters row">
      <div className="col-12 col-sm-6 col-lg-3">
        <PrototypeStencilType
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Type', parameters.prototype_stencil_type, 'required')} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <ApertureCount
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Aperture Count', parameters.aperture_count, 'required')} />
      </div>
      <div className="col-6 col-lg-3">
        <StencilFlap
          required
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Flaps', parameters.flap, 'required')} />
      </div>
      <div className="col-6 col-lg-3">
        <StencilAlignment
          required
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Alignment', parameters.alignment, 'required')} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <StencilLength
          required
          parameters={parameters}
          options={stencilLengthOptions}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencil Length', parameters.stencil_length, 'required')} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <StencilWidth
          required
          parameters={parameters}
          options={stencilsWidthOptions}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Width', parameters.stencil_width, 'required')} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <StencilThickness
          required
          name="stencil_thickness"
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Thickness', parameters.stencil_thickness, 'required')} />
      </div>
      <div className="col-12 col-sm-6 col-lg-3">
        <StencilFiducialData
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Fiducial Data', parameters.fiducial_data, 'required')} />
      </div>
    </div>
  );
};

PrototypeSmtStencil.prototype = {
  product: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  reference: PropTypes.number.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
};

export default PrototypeSmtStencil;
